












import { Vue, Component } from "vue-property-decorator";
import VerticalMenuItem from './VerticalMenuItem.vue'

import vertMenuItemsPatient from './vertMenuItemsPatient.js'
import vertMenuItemsPsychologist from './vertMenuItemsPsychologist.js'
import vertMenuItemsCompany from './vertMenuItemsCompany.js'

@Component({
  components: {
    VerticalMenuItem,
  },
})
export default class VerticalMenu extends Vue {
  get menuItems() {
    //console.log('activeUser', this.$store.state.activeUser);
    //console.log('activeCompany', this.$store.state.activeCompany);
    if (this.$store.state.activeCompany && this.$store.state.activeCompany?.id && this.$store.state.activeCompany?.cnpj) {
      return vertMenuItemsCompany;
    } else {
      const userRole = this.$store.state.activeUser?.role;
      if (userRole === "PATIENT") {
        return vertMenuItemsPatient;
      } else {
        return vertMenuItemsPsychologist;
      }
    } 
  }
}
